export class BrandTestimonialsScroll {
  wrapper: HTMLElement
  logos: HTMLElement
  logoElements: NodeListOf<HTMLElement>
  logoCount: number

  constructor(wrapper: HTMLElement) {
    this.wrapper = wrapper
    this.logos = wrapper.querySelector(".brand-testimonials__logos") as HTMLElement
    this.logoElements = this.logos.querySelectorAll(".brand-testimonials__logo")
    if (!this.logos) return

    this.logoCount = this.logoElements.length / 2

    this.updateScrollDistance()
    window.addEventListener("resize", () => this.updateScrollDistance())
  }

  updateScrollDistance() {
    const gap = parseFloat(getComputedStyle(this.logos).gap) || 0

    let singleSetWidth = gap
    for (let i = 0; i < this.logoCount; i++) {
      const logo = this.logoElements[i] as HTMLElement
      singleSetWidth += logo.offsetWidth
      if (i < this.logoCount - 1) {
        singleSetWidth += gap
      }
    }

    this.logos.style.setProperty("--scroll-distance", `-${singleSetWidth}px`)
  }
}

window.addEventListener("load", () => {
  const wrapper = document.querySelector(".brand-testimonials__logos-wrapper") as HTMLElement
  if (wrapper) {
    new BrandTestimonialsScroll(wrapper)
  }
})
